import moment from 'moment-timezone';

export function formatToAPIDateTime(dateTime, timeZone) {
  const timeZoneDT = moment.tz(dateTime, timeZone);
  timeZoneDT.utc();
  return timeZoneDT.format('YYYY-MM-DDTHH:mm');
}
